import apiClient from "../config/apiClient";

// Wallet ledger for a patient, sourced from account_deposits on the backend.
// Returns { balance, totalFunded, totalUsed, funding[], usage[], history[] }.
// `filter` = 'funding' | 'usage' | 'all'.
export const fetchDepositHistory = async (patientId, filter = "all") => {
  const token = window.localStorage.getItem("token");
  const query = filter && filter !== "all" ? `&filter=${filter}` : "";
  return await apiClient.get(
    `/public/portal?url=patient/${patientId}/deposit-history${query}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

// Current wallet balance only.
export const fetchDepositBalance = async (patientId) => {
  const token = window.localStorage.getItem("token");
  return await apiClient.get(
    `/public/portal?url=patient/${patientId}/deposit-balance`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
